//Generated File 
export default class ReportType{
	static readonly BasedOnAnotherReport = `BasedOnAnotherReport`;
	static readonly Dashboard = `Dashboard`;
	static readonly NotificationTemplate = `NotificationTemplate`;
	static readonly ScreenReport = `ScreenReport`;
	static readonly UserForm = `UserForm`;
	static readonly UserList = `UserList`;
	static readonly UserReport = `UserReport`;
}
